import { Box } from '@mantine/core'

import { colors } from 'src/theme/colors'

type CategoryTagProps = {
  label: string
  color?: string
  size?: 'sm' | 'md'
}

/**
 * Shared category pill — a light tinted background, colored border and colored
 * text, keyed off the category's colour. Used on article cards and detail pages
 * so the tag looks identical everywhere.
 */
export const CategoryTag = ({
  label,
  color,
  size = 'sm'
}: CategoryTagProps) => {
  const tagColor = color ?? colors.primary
  const isMd = size === 'md'

  return (
    <Box
      component="span"
      display="inline-block"
      fz={isMd ? 12 : 10}
      fw={700}
      tt="uppercase"
      px={isMd ? 11 : 8}
      py={isMd ? 4 : 3}
      bdrs={999}
      style={{
        color: tagColor,
        backgroundColor: `color-mix(in srgb, ${tagColor} 16%, white)`,
        border: `1px solid color-mix(in srgb, ${tagColor} 35%, white)`,
        letterSpacing: '0.03em',
        lineHeight: 1.4
      }}
    >
      {label}
    </Box>
  )
}
